<template>
  <div class="player">
    <AudioControlsGroup :idPodcast="podcast.id" :isWithoutSkip="true" />
    <div class="player__box" @click="openContent()">
      <TimeIndicator :currentTime="currentTimeFormat" :durationTime="durationTimeAudioFormat" :adjustedRemainingTime="adjustedRemainingTimeFormat" />
      <p class="player__timecode">{{ podcast.timecodes[currentTimecodeId] }}</p>
    </div>
    <CloseButton class="player__close" @click="closePlayer()"/>
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';
  import { useAudioPlayerState } from '../../composables/computedValues';
  import { useContentPopup } from '../../imports/callContentPopup';
  //-------------------------------------
  import AudioControlsGroup from '../AudioControlsGroup/AudioControlsGroup.vue';
  import TimeIndicator from '../../ui/TimeIndicator/TimeIndicator.vue';
  import CloseButton from '../../ui/CloseButton/CloseButton.vue';
  //-------------------------------------
  const store = useStore();
  //-------------------------------------
  const { podcast, currentTimeFormat, durationTimeAudioFormat, adjustedRemainingTimeFormat, currentTimecodeId } = useAudioPlayerState();
  //-------------------------------------
  const { openContentPopup } = useContentPopup();
  //-------------------------------------
  //Закрыть панель
  const closePlayer = () => store.dispatch('Audioplayer/closeStickyPanel', false);
  //Открыть попап с контентом
  const openContent = () => {
    if(!podcast.value) return;
    openContentPopup(podcast.value.object_id);
  }
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>